export default class Roles {
  static ADMIN = "admin";
  static SHEPHERD = "shepherd";
  static USER = "user";
  static SUPER = "super";
  static RECORDER = "recorder";
  static ROLES = [Roles.ADMIN, Roles.RECORDER, Roles.SHEPHERD, Roles.SUPER];
  static ROLES_LABELS = ["Admin", "Recorder", "Shepherd", "Super"];
}
